module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-tired.c8a95f06.png";